<template>
  <v-layout align-content-center justify-center>
      <v-card width="100%"
      flat
       :class="{
        'pa-4 mt-4': $vuetify.breakpoint.smAndUp,
        'pa-4 mt-4 mx-4': $vuetify.breakpoint.xs,
      }"
      >
        <v-card-text class="text-center">
          <v-icon color="primary" class=" vicon-noaccess"
            >icons8-no-access</v-icon
          >
          <h2 class="font-weight-bold primary--text my-5">Access denied</h2>
          <span  class="subtitle-1  my-5"
            >You are not authorized to access this page. Please go back to return to home.</span
          >
        
          
        </v-card-text>
      </v-card>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";

export default {
  name: "RestrictedPage",
  data() {
    return {};
  },
  computed: {},
  methods: {
    goToLink: function() {
      this.$router.push("/").catch((err) => {});
    },
  },
};
</script>

<style>

</style>
